import {store} from '../lib/store'
import {api} from '../lib/api'

export function systemComment(action) {
	if (action == 'approved') {
		return 'Согласовано'
	}
	else if (action == 'rejected') {
		return 'Отклонено'
	}
	else if (action == 'withdraw') {
		return 'Решение отозвано'
	}
	else if (action == 'drop') {
		return 'Согласования сброшены'
	}
	else if (action == 'changed') {
		return 'Ордер изменен'
	}
	else if (action == 'paid') {
		return 'Ордер оплачен'
	}
}
export function systemIcon(action) {
	if (action == 'approved'
		|| action == 'paid'
	) {
		return {
			name: 'check_circle',
			color: 'green'
		}
	}
	else if (action == 'withdraw') {
		return {
			name: 'undo',
			color: 'white'
		}
	}
	else if (action == 'rejected') {
		return {
			name: 'remove_circle',
			color: 'red'
		}
	}
	else if (action == 'changed') {
		return {
			name: 'edit',
			color: 'deep-orange'
		}
	}
	else {
		return {
			name: '',
			color: ''
		}
	}
}
